export const colors = {
    // Brand — Electric Violet
    primary: {
        50: '#f5f3ff',
        100: '#ede9fe',
        200: '#ddd6fe',
        300: '#c4b5fd',
        400: '#a78bfa',
        500: '#8b5cf6', // violet-500 — main brand
        600: '#7c3aed',
        700: '#6d28d9',
        800: '#5b21b6',
        900: '#4c1d95',
        950: '#2e1065',
    },
    // Accent — Neon Mint / Cyan
    accent: {
        50: '#ecfdf9',
        100: '#d1faf0',
        200: '#a7f3e0',
        300: '#6ee7cc',
        400: '#2dd4b4',
        500: '#00d9b4', // neon mint — main accent
        600: '#00b89a',
        700: '#00937c',
        800: '#007462',
        900: '#00614f',
    },
    // Neutrals — void blacks
    neutral: {
        0: '#ffffff',
        50: '#f0eeff', // slightly violet-tinted white
        100: '#d4d0e8',
        200: '#a8a4bf',
        300: '#7d7a96',
        400: '#56566a',
        500: '#3a3a50',
        600: '#262635',
        700: '#18181f',
        800: '#0d0d1a',
        900: '#080812',
        950: '#020205',
    },
    // Semantic
    success: { light: '#34d399', dark: '#10b981' },
    warning: { light: '#fbbf24', dark: '#f59e0b' },
    error: { light: '#f87171', dark: '#ef4444' },
    info: { light: '#60a5fa', dark: '#3b82f6' },
};
export const typography = {
    fontFamily: {
        sans: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        mono: "'JetBrains Mono', 'Fira Code', monospace",
        display: "'Cormorant Garamond', Georgia, serif",
    },
    fontSize: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.75rem',
        '7xl': '4.5rem',
    },
    fontWeight: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
    },
    lineHeight: {
        tight: 1.2,
        snug: 1.35,
        normal: 1.5,
        relaxed: 1.65,
        loose: 2,
    },
    letterSpacing: {
        tighter: '-0.06em',
        tight: '-0.03em',
        normal: '0em',
        wide: '0.05em',
        wider: '0.08em',
        widest: '0.15em',
    },
};
export const spacing = {
    0: '0',
    0.5: '0.125rem',
    1: '0.25rem',
    1.5: '0.375rem',
    2: '0.5rem',
    2.5: '0.625rem',
    3: '0.75rem',
    3.5: '0.875rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
    40: '10rem',
    48: '12rem',
    56: '14rem',
    64: '16rem',
};
export const borderRadius = {
    none: '0',
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    full: '9999px',
};
export const shadows = {
    sm: '0 1px 3px 0 rgb(0 0 0 / 0.5)',
    md: '0 4px 16px -1px rgb(0 0 0 / 0.6), 0 0 1px rgba(255,255,255,0.04)',
    lg: '0 12px 32px -3px rgb(0 0 0 / 0.7), 0 0 1px rgba(255,255,255,0.05)',
    xl: '0 24px 48px -5px rgb(0 0 0 / 0.8), 0 0 1px rgba(255,255,255,0.06)',
    '2xl': '0 40px 80px -8px rgb(0 0 0 / 0.9), 0 0 1px rgba(255,255,255,0.06)',
    glow: '0 0 24px rgb(139 92 246 / 0.55), 0 0 60px rgb(139 92 246 / 0.2)',
    glowAccent: '0 0 24px rgb(0 217 180 / 0.55), 0 0 60px rgb(0 217 180 / 0.2)',
    inner: 'inset 0 2px 6px 0 rgb(0 0 0 / 0.4)',
};
export const transitions = {
    fast: '120ms ease',
    base: '220ms cubic-bezier(0.16, 1, 0.3, 1)',
    slow: '450ms cubic-bezier(0.16, 1, 0.3, 1)',
    spring: '600ms cubic-bezier(0.34, 1.56, 0.64, 1)',
};
export const zIndex = {
    behind: -1,
    base: 0,
    raised: 10,
    dropdown: 100,
    sticky: 200,
    overlay: 300,
    modal: 400,
    toast: 500,
};
export const breakpoints = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
};
//# sourceMappingURL=tokens.js.map